import { render } from "./MasterApp.vue?vue&type=template&id=54eaf84a"
import script from "./MasterApp.vue?vue&type=script&lang=js"
export * from "./MasterApp.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/giulietta/giulietta/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__